import { render, staticRenderFns } from "./EventEmptyNoneLayout.vue?vue&type=template&id=0b449330"
import script from "./EventEmptyNoneLayout.vue?vue&type=script&lang=js"
export * from "./EventEmptyNoneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports